let defaultAjaxWrapperConfig = {
    type: "GET",
    dataType: undefined,
    success: () => {},
    failure: () => {},
    beforeSend: () => {},
    complete: () => {},
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
    headers: []
};

class AjaxWrapper {
    call(customAjaxWrapperConfig) {
        let config = Object.assign(defaultAjaxWrapperConfig, customAjaxWrapperConfig);

        $.ajax({
            type: config.type,
            url: config.url,
            dataType: config.dataType,
            data: config.data,
            headers: config.headers,
            success: data => config.success(data),
            error: (xhr, textStatus, errorThrown) => {
                if (xhr.status === 401) {
                    window.location.reload();
                }

                config.failure(xhr, textStatus, errorThrown);
            },
            beforeSend: () => config.beforeSend(),
            complete: () => config.complete()
        });
    }
}

module.exports = new AjaxWrapper();
